// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeTextBlockEditTemplate_heading__lOLTm","buttonLink":"LandscapeTextBlockEditTemplate_buttonLink__-Ayk4"};